// Generated from /src/shared/components/internal/Filter/serialization/SearchSyntax.g4 by ANTLR 4.9.3
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete generic visitor for a parse tree produced by SearchSyntaxParser.

export default class SearchSyntaxVisitor extends antlr4.tree.ParseTreeVisitor {
  // Visit a parse tree produced by SearchSyntaxParser#query.
  visitQuery(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#expression.
  visitExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#field.
  visitField(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#fieldMatch.
  visitFieldMatch(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#fieldMatchRange.
  visitFieldMatchRange(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#fieldMatchValue.
  visitFieldMatchValue(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#fieldMatchNull.
  visitFieldMatchNull(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#fieldMatchFunction.
  visitFieldMatchFunction(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#fieldMatchFunctionArg.
  visitFieldMatchFunctionArg(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#fieldComparison.
  visitFieldComparison(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#value.
  visitValue(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#comparable.
  visitComparable(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#dateTimeExpr.
  visitDateTimeExpr(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#dateTimeOperation.
  visitDateTimeOperation(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#date.
  visitDate(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#dateTime.
  visitDateTime(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#dateTimeRound.
  visitDateTimeRound(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#dateTimeMath.
  visitDateTimeMath(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#number.
  visitNumber(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#string.
  visitString(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#word.
  visitWord(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by SearchSyntaxParser#ip.
  visitIp(ctx) {
    return this.visitChildren(ctx);
  }
}
